import { Component, ViewChild, OnInit, OnDestroy, Renderer2, Injector, signal, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { LeadsRegistrationService } from '../../adapters/leadsRegistration.service';
import { BsInquiryInsuranceInfoService } from '../../adapters/bsInquiryInsuranceInfo.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GetDiscountInfoService } from 'src/app/adapters/getDiscountInfo.service';
import { formatDate } from '@angular/common';
import { BsInquiryCoverageMotorMappingService } from 'src/app/adapters/bsInquiryCoverageMotorMapping.service';
import { TiscoModalComponent } from 'src/app/shared/component/tisco-modal/tisco-modal.component';

import { BsInquiryFactorConditionService } from 'src/app/adapters/bsInquiryFactorCondition.service';
import { GetContractReasonService } from 'src/app/adapters/getContractReason.service';
import { pad, getStorage, formatMoney } from 'src/app/core/utilities';
import { EventService } from 'src/app/adapters/event.service';
import { GetAllProductService } from 'src/app/adapters/getAllProduct.service';
import { BaseComponents } from '../../base.component';
import { environment } from 'src/environments/environment';
import { RecaptchaVerifyService } from 'src/app/adapters/recaptchaVerify.service';
import { GetAllBuildingTypeService } from 'src/app/adapters/getAllBuildingType.service';
import { GetAllPropertyTypeService } from 'src/app/adapters/getAllPropertyType.service';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { Title, Meta } from '@angular/platform-browser';
import { GoogleTagService } from 'src/app/core/tag/google-tag.service';
import { getShortUrlVariableService } from 'src/app/adapters/getShortUrlVariable.service';
import { GetLocationAllService } from 'src/app/adapters/getLocationAll.service';
import { GetMaskingService } from '../../adapters/getMasking.service';
// import { GetTextFormConfirm } from '../../adapters/getTextFormConfirm.service'
import { formsParams } from 'src/app/interfaces/form.interface';
import * as uuid from "uuid";
@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class FormComponent extends BaseComponents implements OnInit, OnDestroy {
	id: any = ''
	securityID: any = 0;
	securityGroupID: any = 0;
	securityTypeID: any = 0;
	securitySubTypeID: any = 0;
	securityGroupName: string = ''
	securityTypeName: string = ''
	securitySubTypeName: string = ''
	securityName: string = ''
	coverage: string = ''  //เบี้ยประกัน
	premium: string = '' //ทุนประกัน
	coverageRange: string = '' //เบี้ยประกัน แบ่งเป็นช่วง
	premiumRange: string = '' //เบี้ยปทุนประกันระกัน แบ่งเป็นช่วง
	banner: any = {};
	content: any = {};
	type: any = '';
	myRecaptcha: boolean;
	captchaToken: string = ''
	product_name = signal<string>('');
	url_brand: string = '';
	cars: any = []
	@ViewChild('f') form: NgForm;

	onSubmitInfo: boolean = false


	model = {
		first_name: '',
		last_name: '',
		telephone_no: '',
		email_address: '',
		special_note_detail: 'product Id:#securitySubTypeID/Promo Code:#promotionCode',
		promotion_code: '',   // *เพิ่มเข้ามาเอง
		referralCode: null,
		province: '',
		district: '',
		pdpa_consent: false
	}
	promotionCode: string = '';

	regName = /^[-.a-zA-Z\sกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮะัาำิีึืฺุูเแโใไ็่้๊๋์]+$/;
	regID = /^[0-9]{13}\d*$/;
	regTel = /^0[1-9][0-9]{7,8}$/;
	decimal = /^\d*$/;
	regZipCode = /^[0-9]{5}\d*$/

	@ViewChild(TiscoModalComponent) modal;

	factor: any = []

	calculateItem: any = {}
	securitySubType: any = {}
	security: any = {}
	productName = signal<string>('')
	buildingType: any = []
	propertyType: any = []
	etcField: any = {};
	YOUR_SITE_KEY: string = environment.siteKey
	subDistrict: string = '';
	district: string = '';
	district_name: string = '';
	province: string = '';
	province_name = signal<string>('');
	province_validate = signal(false);
	district_validate = signal(false);
	results: any = {};
	isLoading: any = false;
	timeout: any = {};
	search: string = '';
	keyword = 'text';
	log_text = 'form'
	hiddendata = signal(false);
	dataAlert: string = null;
	url_2: string = '';
	utm_medium: string;
	utm_source: string;
	utm_content: string;
	utm_term: string;
	utm_campaign: string;
	constructor(
		protected injectorObj: Injector,
		private leadsRegistrationService: LeadsRegistrationService,
		private route: ActivatedRoute,
		private bsInquiryInsuranceInfoService: BsInquiryInsuranceInfoService,
		private getDiscountInfoService: GetDiscountInfoService,
		private bsInquiryCoverageMotorMappingService: BsInquiryCoverageMotorMappingService,
		private bsInquiryFactorConditionService: BsInquiryFactorConditionService,
		private getContractReasonService: GetContractReasonService,
		private eventService: EventService,
		private getAllProductService: GetAllProductService,
		//private logger: NGXLogger,
		private recaptchaVerifyService: RecaptchaVerifyService,
		private getAllBuildingTypeService: GetAllBuildingTypeService,
		private getAllPropertyTypeService: GetAllPropertyTypeService,
		private recaptchaV3Service: ReCaptchaV3Service,
		private renderer: Renderer2,
		private titleService: Title,
		private googleTageService: GoogleTagService,
		private shortUrl: getShortUrlVariableService,
		private router: Router,
		private getLocationAllService: GetLocationAllService,
		// private getTextFormConfirm: GetTextFormConfirm,
		public getMaskingService: GetMaskingService
	) {
		super(injectorObj);
	}

	ngAfterViewInit() {
		setTimeout(() => {
			//this.renderer.setStyle((document.querySelector('.grecaptcha-badge')),'display','block')
		}, 3000);
	}

	async ngOnInit() {
		this.log_text += ` ${uuid.v4()} => `;
		let el = document.querySelector('.grecaptcha-badge')
		if (el) {
			this.renderer.setStyle((document.querySelector('.grecaptcha-badge')), 'display', 'block')
		}
		if (this.router.url.indexOf("formnoheader") >= 0) {
			this.hiddendata.set(true);
		}
		await this.onInitPage()
	}

	async ngOnDestroy() {
		let el = document.querySelector('.grecaptcha-badge')
		if (el) {
			this.renderer.setStyle((document.querySelector('.grecaptcha-badge')), 'display', 'none')
		}
	}

	async onInitPage() {
		let logFunction = `${this.log_text} onInitPage`;
		this.logger.info([`${logFunction} start`]);
		this.myRecaptcha = false
		this.captchaToken = ''
		let calculateItems = getStorage('calculateItems') || [];
		let calculateItem = [];
		await this.route.params.subscribe(
			async params2 => {
				let calculateItems = getStorage('calculateItems') || [];
				let calculateItem = [];
				this.logger.info([`${logFunction} calculateItems:`, calculateItems]);
				await this.route.queryParams.subscribe(async (params:formsParams) => {
					if(params?.utm_medium?.trim()){
						this.utm_medium = params.utm_medium;
					}
					if(params?.utm_source?.trim()){
						this.utm_source = params.utm_source;
					}
					if(params?.utm_content?.trim()){
						this.utm_content = params.utm_content;
					}
					if(params?.utm_term?.trim()){
						this.utm_term = params.utm_term;
					}
					if(params?.utm_campaign?.trim()){
						this.utm_campaign = params.utm_campaign
					}
					if (params?.id?.trim()) {
						this.logger.info([`${logFunction} params.id:`, params.id]);
						calculateItem = calculateItems.filter(item => { return item.id == params.id })
						console.log('params.id', params.id)
						console.log('calculateItems', calculateItems)
						console.log('calculateItem', calculateItem)
						if (calculateItem.length > 0) {
							this.logger.info([`${logFunction} calculateItems > 0`]);
							this.id = calculateItem[0]['id']
							this.calculateItem = calculateItem[0]['model']
							this.logger.info([`${logFunction} calculateItems id:`, this.id]);
							this.logger.info([`${logFunction} calculateItems model:`, this.calculateItem]);
							if (calculateItem[0]['customValue']) {
								this.coverage = calculateItem[0]['customValue']['coverage'] || '';
								this.premium = calculateItem[0]['customValue']['premium'] || '';
								this.coverageRange = calculateItem[0]['customValue']['coverageRange'] || '';
								this.premiumRange = calculateItem[0]['customValue']['premiumRange'] || '';
							}

							this.logger.debug('form modelData', this.calculateItem)

						}
					}

					if (params?.model_id?.trim()) {
						this.etcField.model_id = params.model_id;
						this.logger.info([`${logFunction} params.model_id:`, params.model_id]);
					}
					if (params?.brand_id?.trim()) {
						this.etcField.brand_id = params.brand_id;
						this.logger.info([`${logFunction} params.brand_id:`, params.brand_id])
					}

					if (params2['url_1']) {
						this.logger.info([`${logFunction} url_1 have value : `, params2['url_1']])
						const url_1 = params2['url_1'] ? "/" + params2['url_1'] : "";
						const url_2 = params2['url_2'] ? "/" + params2['url_2'] : "";
						const url_3 = params2['url_3'] ? "/" + params2['url_3'] : "";
						this.logger.info([`${logFunction} url_1`, params2['url_1']])
						this.url_2 = url_2;
						// const url_1andurl_2 = params2['url_1'] + "/" + params2['url_2'];
						// this.dataAlert = await this.getFormConfirmAlert(url_1andurl_2);						
						if (params2['url_1'] == 'heath-insurance' || params2['url_1'] == 'health-insurance') {
							this.logger.info([`${logFunction} url_1 check condition success`, params2['url_1']])
							let checkurl2 = params2['url_2'];
							if (checkurl2 == 'ci-extra-care' || checkurl2 == 'smart-ci' || 'my-care-easy-health') {
								this.logger.info([`${logFunction} url_2 check condition success`, checkurl2])
								this.product_name.set(checkurl2);
								this.searchLocation('', 'province');
							}
						} else if (params2['url_1'] == 'life-insurance') {
							this.logger.info([`${logFunction} url_1 life-insurance check condition success`, params2['url_1']])
							this.product_name.set(params2['url_1']);
							this.searchLocation('', 'province');
						}

						this.url_brand = params2['url_2'];
						this.logger.info([`${logFunction} url_brand:`, this.url_brand]);
						const body = { 'web_url': 'https://www.tiscoinsure.com/products' + url_1 + url_2 + url_3 };
						this.logger.info([`${logFunction} body shortUrl`, body])
						const data_resp: any = await this.shortUrl.exec(body);
						this.logger.info([`${logFunction} response`, data_resp]);
						console.log("ข้อมูลพาราม : ", data_resp);
						// this.queryData = params2;
						this.securityID = data_resp.securityID || '';
						this.securityGroupID = parseInt(data_resp.securityGroupID) || 0;
						this.securityTypeID = parseInt(data_resp.securityTypeID) || 0;
						this.securitySubTypeID = parseInt(data_resp.securitySubTypeID) || 0;

					} else {
						this.logger.info([`${logFunction} url_1 is null`])
						this.securityID = params.securityID || 0;
						this.securityGroupID = parseInt(params.securityGroupID) || 0;
						this.securityTypeID = parseInt(params.securityTypeID) || 0;
						this.securitySubTypeID = parseInt(params.securitySubTypeID) || 0;

						const getShortUrl = {
							securityGroupID: params.securityGroupID,
							securityTypeID: params.securityTypeID,
							securitySubTypeID: params.securitySubTypeID,
							securityID: params.securityID
						};
						this.logger.info([`${logFunction} body getShortUrl:`, getShortUrl])
						const resp_short: any = await this.shortUrl.exec(getShortUrl);
						if (resp_short) {
							this.logger.info([`${logFunction} get shortUrl success:`, resp_short])
							// console.log(resp_short);
							if (resp_short.web_url) {
								this.logger.info([`${logFunction} resp_short.web_url:`, resp_short.web_url])
								const blog_url = new URL(resp_short.web_url);
								blog_url.pathname;
								const param_send: any = JSON.parse(JSON.stringify(params));
								console.log(param_send);
								delete param_send.securityGroupID;
								delete param_send.securityTypeID;
								delete param_send.securitySubTypeID;
								delete param_send.securityID;
								this.router.navigate(['/form' + blog_url.pathname], { queryParams: param_send });
								return;
							}
						}

					}
					this.type = params.type || '';
					// this.coverage = params.coverage || '';
					// this.premium = params.premium || '';

					//console.log(params)

					if (this.securityGroupID == 4) {
						this.logger.info([`${logFunction} securityGroupID = 4`])
						let body = { "securityGroupID": this.securityGroupID, "securityTypeID": this.securityTypeID, "securitySubTypeID": null, "assetType": null }
						this.logger.info([`${logFunction} securityGroupID = 4 body:`, body]);
						this.bsInquiryCoverageMotorMappingService.exec(body).then((res: any) => {
							if (res.response_code == "40000") {
								this.logger.info([`${logFunction} securityGroupID = 4 bsInquiryCoverageMotorMappingService success`]);
								res.data.forEach(v => {
									//let brand = {id: v.brandID,name: v.brandNameTH};
									this.cars['b' + v.brandID] = v.brandNameTH
									v.model.forEach(val => {
										//let model = {id: val.modelID,name: val.modelNameTH};
										this.cars['b' + v.brandID + 'm' + val.modelID] = val.modelNameTH
									});

								});
							}
							//this.logger.debug(this.cars)
						})
					} else if (this.securityGroupID == 5) { //ประกันบ้าน
						this.logger.info([`${logFunction} securityGroupID = 5 start`])
						this.buildingType = await this.getAllBuildingType()  //ชนิดโครงสร้างบ้าน
						this.propertyType = await this.getAllPropertyType()  //ประเภทสิ่งปลูกสร้าง
					}
					this.logger.info([`${logFunction} getProductName securityID:`, this.securityID])
					let data = await this.getProductName({ securityID: this.securityID })
					if (data) {
						this.logger.info([`${logFunction} getProductName securityID found data:`, data])
						this.securityGroupID = data.securityGroupID
						this.securityGroupName = data.securityGroupName
						this.securityTypeID = data.securityTypeID
						this.securityTypeName = data.securityTypeName
						this.securitySubTypeID = data.securitySubTypeID
						this.securitySubTypeName = data.securitySubTypeName
						this.securityID = data.securityID
						this.securityName = data.securityName

						this.productName.set(data.securitySubTypeName + ' ' + data.securityName)
						this.googleTageService.setEventTage("TISCO Insure Interesting: " + this.productName());
					} else {
						this.logger.info([`${logFunction} getProductName securityID not found data`])
						this.logger.info([`${logFunction} getProductName securitySubTypeID:`, this.securitySubTypeID])
						let securitySubType = await this.getProductName({ securitySubTypeID: this.securitySubTypeID })
						if (securitySubType) {
							this.logger.info([`${logFunction} getProductName securitySubType:`, securitySubType])
							this.securityGroupID = securitySubType.securityGroupID
							this.securityGroupName = securitySubType.securityGroupName
							this.securityTypeID = securitySubType.securityTypeID
							this.securityTypeName = securitySubType.securityTypeName
							this.securitySubTypeID = securitySubType.securitySubTypeID
							this.securitySubTypeName = securitySubType.securitySubTypeName
							this.securityID = 0
							this.securityName = ''
							this.productName.set(securitySubType.securitySubTypeName)
							this.googleTageService.setEventTage("TISCO Insure Form Interesting: " + this.productName());
						} else {
							this.logger.info([`${logFunction} getProductName securitySubType not have value`])
						}

					}

					this.getFactorConditionValue()
				})
			});
	}

	async getAllBuildingType() {
		return await this.getAllBuildingTypeService.exec({}).then((res: any) => {
			return res
		}).catch(e => {
			this.logger.error('error build type all', e)
			return []
		})
	}

	async getAllPropertyType() {
		return await this.getAllPropertyTypeService.exec({}).then((res: any) => {
			return res
		}).catch(e => {
			this.logger.error(e)
			return []
		})
	}

	onChangeSearch2(search: string, type: string, mode: string = 'current') {
		if (this.timeout[type]) {
			clearTimeout(this.timeout[type]);
		}
		this.timeout[type] = setTimeout(() => {
			this.searchLocation(search, type);
			console.log(this.results);
		}, 1);
	}
	onSelect2(item: any, type: string, mode: string = 'current') {

		if (item.data) {
			if (type == 'province') {
				this.province = item.data.name;
				this.province_name.set(item.data.name)
				this.province_validate.set(false);
				if (this.province_name() == 'กรุงเทพมหานคร') {
					this.searchLocation('', 'district')
				}
			} else {
				this.district = item.data.name;
				this.district_name = item.data.name;
				this.district_validate.set(false);
			}
			// this.district = item.data.district;
			// this.province = item.data.province;	
		} else {
			if (type == 'province') {
				this.province = '';
				this.province_name.set('');
			} else {
				this.district = '';
				this.district_name = '';
			}
			// let arr = ['subDistrict', 'subDistrictText', 'district', 'districtText', 'province', 'provinceText', 'postCode', 'zipCode'];
			// arr.map(val => {
			// 	if (val != type + 'Text') {
			// 		this.model.address[mode][val] = null;
			// 	}
			// });
		}
	}

	onClearSelect(type) {
		if (type == 'province') {
			this.province = '';
			this.province_name.set('');
		} else {
			this.district = '';
			this.district_name = '';
		}
	}

	// async getFormConfirmAlert(url_params) {
	// 	let logFunction = `${this.log_text} getFormConfirmAlert`;
	// 	try {
	// 		this.logger.info([`${logFunction} url_params:`, url_params])
	// 		const res = await this.getTextFormConfirm.exec({ url_params: url_params });
	// 		if (res["response_code"] == "40000") {
	// 			this.logger.info([`${logFunction} response : `, res["response_data"]]);
	// 			return res["response_data"]
	// 		} else {
	// 			this.logger.info([`${logFunction} getTextFormConfirm data not found`]);
	// 			return null;
	// 		}
	// 	} catch (error) {
	// 		this.logger.info([`${logFunction} error:`, error.message]);
	// 		return null;
	// 	}
	// }

	async searchLocation(search, type, mode = 'current') {
		let bodyLocation = {
			type: type,
			search: search,
			province: this.province_name()
		}
		// "subDistrict": type == "subDistrict" ? search : '',
		// "district": type == "district" ? search : '',
		// "province": type == "province" ? search : '',
		// "postCode": type == "postCode" ? search : ''
		this.getLocationAllService.exec(bodyLocation).then((res: any) => {
			this.isLoading = false;
			if (res.response_code == "40000") {
				this.results[type] = res.response_data.map((repo: any) => {
					return {
						text: repo.name,
						markup: repo.name,
						value: repo.name,
						data: repo
					};
				});
			} else {
				this.results[type] = [];
			}

		})

	}

	async getProductName(body: any = {}) {
		if (body.securityID) {
			return await this.getAllProductService.exec({
				securityID: body.securityID,
			}).then((res: any) => {
				//this.logger.debug(res)
				let i = res['data']['security'][0]
				if (i) {
					return res['data']['security'][0]
				} else {
					return null
				}

			}).catch(e => {
				this.logger.error(e)
				return null
			})
		} else if (body.securitySubTypeID) {
			return await this.getAllProductService.exec({
				securitySubTypeID: body.securitySubTypeID,
			}).then((res: any) => {
				//this.logger.debug(res)
				let i = res['data']['securitySubType'][0]
				if (i) {
					return res['data']['securitySubType'][0]
				} else {
					return null
				}

			}).catch(e => {
				this.logger.error(e)
				return null
			})
		} else {
			return null
		}
	}

	async getAllProduct(body) {
		return await this.getAllProductService.exec(body).then((res: any) => {
			//this.logger.debug(res)
			return res['data']
		}).catch(e => {
			this.logger.error(e)
			return null
		})
	}

	//ข้อมุลทุนประกัน
	private getFactorConditionValue() {
		let logFunction = `${this.log_text} getFactorConditionValue => `;
		let body = { "securityGroupID": +this.securityGroupID, "securityTypeID": +this.securityTypeID };
		this.logger.info([`${logFunction} bsInquiryFactorConditionService body:`, body])
		this.bsInquiryFactorConditionService.exec(body).then((res: any) => {
			if (res.response_code == "40000") {
				this.logger.info([`${logFunction} bsInquiryFactorConditionService success`])
				for (let i = 1; i <= 10; i++) {
					this.factor[i] = res['data']['factor'].filter(item => item.name == i)[0] || {};

					if ((i == 3 || i == 4 || i == 8) && this.factor[i]) { //เบี้ยประกัน,ทุนประกัน,ค่าห้อง
						if (this.factor[i].from) {
							//this.logger.debug(this.factor[i])
						}
					}
				}
				//this.logger.debug(this.factor)
			}
		})
	}

	getContractReason(): Promise<any> {
		let promoCode = this.model.promotion_code || (this.publicCode != '-' ? this.publicCode : '')
		return this.getContractReasonService.exec({ securityGroupID: this.securityGroupID, securityID: this.securityID, promoCode: promoCode }).then(r => {
			return Promise.resolve(r[0]['name'])
		}).catch(() => {
			return Promise.resolve('')
		})
	}


	public addClass(f: NgForm, field: string, msg?: string) {
		let iClass = [];
		if (f.form.get(field) && msg !== 'msg') {
			if (f.form.get(field).invalid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
				iClass.push('uk-form-danger')
			} else if (f.form.get(field).valid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
				iClass.push('uk-form-success')
			}
		} else if (f.form.get(field) && msg == 'msg') {
			if (f.form.get(field).invalid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
				iClass.push('uk-animation-fade')
			} else if (f.form.get(field).valid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
				iClass.push('uk-animation-reverse')
			}
		}

		return iClass
	}
	
	onSubmit(token) {
		let logFunction = `${this.log_text} onSubmit => `;
		this.onSubmitInfo = true;
		const productNote = "Product & Plan: " + (this.productName() ? this.productName() : '-')
		const promotionNote = "Promo code: " + (this.model.promotion_code ? this.model.promotion_code : '-')
		const referralNote = "Referral code: " + (this.model.referralCode ? this.model.referralCode: '-')
		let body: any = {
			lead_reference_no: '',//'P' + formatDate(new Date(), 'yyyyMMddHHmmssmmm', 'en'), //text เลขอ้างอิงของ Lead
			product_id: this.securitySubTypeID, //1 integer	หมายเลขอ้างอิงข้อมูลผลิตภัณฑ์และบริการ
			product_name: this.securitySubTypeName || '', //1	textผลิตภัณฑ์
			first_name: this.model.first_name, //	text ชื่อ
			last_name: this.model.last_name, //text นามสกุล
			telephone_no: this.model.telephone_no, //text	เบอร์โทรศัพท์
			email_address: this.model.email_address, //text อีเมล
			source_of_data_id: 7,  //integer	แหล่งที่มาของข้อมูล
			source_of_data_desc: 'MyProtection-Website', //text	แหล่งที่มาของข้อมูล
			reason_id: 0, //integer	เหตุผล
			//get_infomation_flag: null, //boolean	รับข่าวสาร
			asset_website_code: 1, //1= สนใจประกัน form lead 2 = มาจากซื้อประกันออนไลน์	integer	สถานะความสนใจในผลิตภัณฑ์
			//reference_id: null, //text	เลขที่อ้างอิง
			gender_id: null,//integer	เพศ
			gender_desc: '', //text	เพศ
			birthdate: null, //datetime	วันเกิด
			//asset_brand_model_id: null, //integer	ยี่ห้อและรุ่นทรัพย์
			brand_desc: null, //text	ยี่ห้อ
			//model_desc: null, //text	รุ่น
			registration_year: null, //datetime	ปีจดทะเบียน
			feature_name_id: this.securityID??0, //	nteger	ชื่อคุณลักษณะ
			feature_name_desc: '', //text	ชื่อคุณลักษณะ
			sum_insrured: null, //decimal	ทุนประกัน
			premium: null, //decimal	เบี้ยประกัน
			special_note_detail: ' ', //	ext	ข้อความ
			contract_reason: ' ',	//text	"ข้อมูลเพิ่มเติม Microsite - My Protection-สนใจประกันMicrosite - My Protection-ซื้อประกันออนไลน์"
			captchaToken: token,
			referral_code: this.model.referralCode, // add referral code
			promotion_code: this.model.promotion_code, // promotion code
			product_identity_id: null,
			security_group_id: +this.securityGroupID,
			security_type_id: +this.securityTypeID,
			security_sub_type_id: +this.securitySubTypeID,
			securities_identity_id: this.securityID == "0" ? null : '' + this.securityID,
			brand_id: null,
			model_id: null,
			security_group_name_th: this.securityGroupName, //for tiscoinsure
			security_type_name_th: this.securityTypeName, //for tiscoinsure
			note: productNote + " / " + promotionNote + " / " + referralNote, //for tiscoinsure
			utm_medium: this.utm_medium || null,
            utm_source: this.utm_source || null,
            utm_content: this.utm_content || null,
            utm_term: this.utm_term || null,
            utm_campaign: this.utm_campaign || null 
		}

		if (this.etcField.brand_id && this.etcField.model_id) {
			body.brand_id = +this.etcField.brand_id;
			body.model_id = +this.etcField.model_id;
		}

		this.getContractReason().then(contract_reason => {
			body.contract_reason = contract_reason

			let birthDate: any = '-'

			body.premium = formatMoney(this.premium, 2, '.', '')
			body.sum_insrured = formatMoney(this.coverage, 2, '.', '')

			let specialNoteDetail = ''
			let promoCode = this.model.promotion_code || this.publicCode
			let specialName = this.productName()
			let premium = body.premium != 0 ? formatMoney(body.premium) : (this.coverageRange || '-')
			let sum_insrured = body.sum_insrured != 0 ? formatMoney(body.sum_insrured) : (this.premiumRange || '-')
			let gender = '-'
			let category = '-'
			let type = '-'
			let area = '-'

			if (this.calculateItem['factor1'] && this.calculateItem['factor1']['id']) {  //เพศ
				if (this.calculateItem['factor1']['value'] != '') {
					body.gender_id = +this.calculateItem['factor1']['value']
					body.gender_desc = this.calculateItem['factor1']['value'] == 1 ? 'ชาย' : 'หญิง'
					gender = body.gender_desc
				}
			}

			if (this.calculateItem['factor2'] && this.calculateItem['factor2']['id']) {  //วดป เกิด
				if (this.calculateItem['birthDate'] && this.calculateItem['birthDate'][0] != '' && this.calculateItem['birthDate'][1] != '' && this.calculateItem['birthDate'][2] != '') {
					birthDate = `${this.calculateItem['birthDate'][0]}/${this.calculateItem['birthDate'][1]}/${this.calculateItem['birthDate'][2]}`;
					body.birthdate = new Date(this.calculateItem['birthDate'][2] + '-' + pad(this.calculateItem['birthDate'][1]) + '-' + pad(this.calculateItem['birthDate'][0]) + ' 00:00:00').getTime();
				}
			}

			//ข้อมูลยี่ห้อรถ
			if (this.calculateItem['factor5'] && this.calculateItem['factor5']['id'] && this.calculateItem['factor5']['value']) {  //ยี่ห้อ
				body.asset_brand_model_id = this.calculateItem['factor5']['value']
				body.brand_desc = this.cars['b' + this.calculateItem['factor5']['value']] || null;  //ชื่อยี่ห้อ
				body.brand_id = (+this.calculateItem['factor5']['value']);
				if (this.calculateItem['factor6']['id'] && this.calculateItem['factor6']['value']) {  //รุ่น
					body.model_id = (+this.calculateItem['factor6']['value']);
					body.model_desc = this.cars['b' + this.calculateItem['factor5']['value'] + 'm' + this.calculateItem['factor6']['value']] || null;  //ชื่อรุ่น
				}

				if (this.calculateItem['factor7']['id'] && this.calculateItem['factor7']['value']) {  //ปีที่จดทะเบียน
					//body.registration_year = +this.calculateItem['factor7']['value'];
					body.registration_year = (new Date().getFullYear()) + 1 - (+this.calculateItem['factor7']['value'])

				}
			}

			//ประเภทสิ่งปลูกสร้าง
			this.propertyType.map((item: any) => {
				if (this.calculateItem.factor9 && this.calculateItem.factor9.value == item.id) {
					category = item.name
					return
				}
			})

			//ชนิดโครงสร้างบ้าน
			this.buildingType.map((item: any) => {
				if (this.calculateItem.factor10 && this.calculateItem.factor10.value == item.id) {
					type = item.name
					return
				}
			})

			//พื้นที่: ${area} ตร.ม.
			if (this.calculateItem.other && this.calculateItem.other.area) {
				area = formatMoney(this.calculateItem.other.area)
			}


			if (this.securityGroupID == 2 || this.securityGroupID == 3 || this.securityGroupID == 6 || this.securityGroupID == 7) {
				specialNoteDetail = `Product & Plan: ${specialName} / ทุน: ${sum_insrured} / เบี้ย: ${premium} / เพศ: ${gender} / วันเกิด: ${birthDate} / Promo code: ${promoCode}`
			} else if (this.securityGroupID == 4) {  //ประกันเกี่ยวกับรถ
				specialNoteDetail = `Product & Plan : ${specialName} / ทุน: ${sum_insrured} / เบี้ย: ${premium} / Promo code: ${promoCode}`
			} else if (this.securityGroupID == 5) {  //ประกันเกี่ยวกับบ้าน
				specialNoteDetail = `Product & Plan : ${specialName}  / ทุน: ${sum_insrured} / เบี้ย: ${premium} / ประเภท: ${category} / ชนิด: ${type} / พื้นที่: ${area} ตร.ม. / Promo code: ${promoCode}`
			}
			specialNoteDetail += ` / Referral code: ${this.model.referralCode ? this.model.referralCode : '-'}`;
			if (!!this.province_name()) {
				specialNoteDetail += '/ จังหวัด: ' + this.province_name;
				if (this.province_name() == 'กรุงเทพมหานคร') {
					specialNoteDetail += '/ เขต : ' + this.district_name;
				}
			}

			body.special_note_detail = specialNoteDetail
			let logbody = {
				...body,
				first_name: this.getMaskingService.maskingData(body.first_name),
				last_name: this.getMaskingService.maskingData(body.last_name),
				telephone_no: this.getMaskingService.maskingData(body.telephone_no),
				email_address: this.getMaskingService.maskingData(body.email_address)
			}
			this.logger.info([`${logFunction} leadsRegistrationService body:`, logbody])
			// this.logger.debug(body)
			// return

			this.openModalWaiting(true)
			this.leadsRegistrationService.exec(body).then((res: any) => {
				if (res.response_code == "40000") {
					let text_modal = "เราได้รับข้อมูลเรียบร้อยแล้ว เจ้าหน้าที่จะติดต่อกลับด้วยเบอร์ 02 633 6060 โปรดระวังผู้แอบอ้างเป็น ทิสโก้อินชัวร์";
					// if(this.dataAlert){
					// 	text_modal = this.dataAlert;
					// }
					if (this.url_brand == "mazda-premium-insurance") {
						text_modal = "เราได้รับข้อมูลเรียบร้อยแล้ว เจ้าหน้าที่จะติดต่อกลับด้วยเบอร์ 02 633 6066 โปรดระวังผู้แอบอ้างเป็น มาสด้าพรีเมียมอินชัวร์";
					} else if (this.url_brand == "ford-ensure") {
						text_modal = "เราได้รับข้อมูลเรียบร้อยแล้ว เจ้าหน้าที่จะติดต่อกลับด้วยเบอร์ 02 633 6080 โปรดระวังผู้แอบอ้างเป็น ฟอร์ดเอนชัวร์";
					} else if (this.url_brand == "nissan-premium-protection") {
						text_modal = "เราได้รับข้อมูลเรียบร้อยแล้ว เจ้าหน้าที่จะติดต่อกลับด้วยเบอร์ 02 633 6040 โปรดระวังผู้แอบอ้างเป็น นิสสันพรีเมียมโพรเทคชั่น";
					} else if (this.url_brand == "great-wall-motor-insurance") {
						text_modal = "เราได้รับข้อมูลเรียบร้อยแล้ว เจ้าหน้าที่จะติดต่อกลับด้วยเบอร์ 02 633 6088 โปรดระวังผู้แอบอ้างเป็น เกรทวอลล์มอเตอร์";
					}
					this.logger.info([`${logFunction} leadsRegistrationService success`])
					let redirectTo = "/thankyounoheader" + this.url_2;
					this.logger.info([`${logFunction} leadsRegistrationService redirectTo:`, redirectTo]);
					this.modal.show({
						title: 'Header Information',
						body: text_modal,
						redirectTo: redirectTo 
					});
				} else {
					this.logger.info([`${logFunction} leadsRegistrationService error`])
					this.modal.show({
						title: 'Header Information',
						body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์'
					});
				}
				this.openModalWaiting(false)
				this.captchaToken = ''
			}).catch(() => {
				this.openModalWaiting(false)
				this.captchaToken = ''
				this.modal.show({
					title: 'Header Information',
					body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์'
				});
			})
			this.onSubmitInfo = false;
		})

	}

	public executeImportantAction(): void {
		this.logger.info(['form executeImportantAction start'])
		let checkvalidate = false;
		if (this.product_name() == 'life-insurance' || this.product_name() == 'ci-extra-care' || this.product_name() == 'smart-ci' || this.product_name() == 'my-care-easy-health') {
			this.logger.info(['form executeImportantAction product_name:', this.product_name()]);
			if (this.province_name() == '') {
				this.logger.info(['form executeImportantAction province_name is null:']);
				checkvalidate = true;
				this.province_validate.set(true);
			} else {
				this.logger.info(['form executeImportantAction province_name have value:']);
				this.province_validate.set(false);
				if (this.province_name() == 'กรุงเทพมหานคร') {
					if (this.district_name == '') {
						this.logger.info(['form executeImportantAction distirct_name is null:']);
						checkvalidate = true;
						this.district_validate.set(true);
					} else {
						this.logger.info(['form executeImportantAction distirct_name have value:']);
						checkvalidate = false;
						this.district_validate.set(false);
					}
				}
			}
		}
		if (checkvalidate == false) {
			this.logger.info(['form executeImportantAction execute']);
			this.onSubmitInfo = true
			this.recaptchaV3Service.execute('importantAction')
				.subscribe(
					(token) => this.onSubmit(token),
					(error) => this.onSubmitInfo = false
				);
		}

	}

	publicCode: string = '-'
	getDiscountInfo = (value: string): Promise<boolean> => {
		let logFunction = `${this.log_text} getDiscountInfo => `;
		this.model.promotion_code = ''
		//this.logger.debug(this.promotionCode,':',this.model.promotion_code,':',value)
		if (this.model.promotion_code === value || value == '') { return Promise.resolve(true); }
		if (value != null && value.length < 3) { return Promise.resolve(false); }
		this.logger.info([`${logFunction} getDiscountInfoService body:`, { promotion_code: value, security_id: this.securityID }])
		return this.getDiscountInfoService.exec({ promotion_code: value, security_id: this.securityID })
			.then((data: any) => {
				this.logger.info([`${logFunction} getDiscountInfoService data:`, data])
				if (data.length > 0 && this.promotionCode == '' && value == null) {
					this.logger.info([`${logFunction} getDiscountInfoService data have value and promotionCode is null and value is null`])
					if (this.publicCode == '-') {
						this.publicCode = data[0].code
					}
					this.promotionCode = data[0].code;
					return true;
				}
				if (data.length > 0 && value != null) {
					this.logger.info([`${logFunction} getDiscountInfoService data have value and value not null`])
					this.model.promotion_code = data[0].code;
					this.logger.debug(this.publicCode, this.model.promotion_code)
					return true;
				} else {
					return false;
				}

			}, error => {
				return true;
			});
	}

	openModalWaiting(isOpen: boolean = true) {
		if (isOpen) {
			this.eventService.loadding.emit(isOpen)
		} else {
			this.eventService.loadding.emit(isOpen)
		}
	}

	async resolved(captchaResponse: string) {
		this.myRecaptcha = false
		this.captchaToken = captchaResponse
		return this.recaptchaVerifyService.exec({ token: captchaResponse }).then(re => {
			if (re['success'] == true) {
				this.myRecaptcha = true
			}
			return this.myRecaptcha
			//console.log(re)
		}).catch(err => {
			return this.myRecaptcha
			//console.log(err)
		})
		//console.log(`Resolved captcha with response: ${captchaResponse}`);
	}



}


